import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  EMPTY_LIST,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { useAsyncCallback } from '../../../hooks'
import { ButtonSelect } from '../../Select'
import { getRequestStatuses } from '../RequestEditStatusModal'
import { RequestStatusSelectInfo } from '../RequestStatusSelectInfo'

import { REQUEST_STATUS_SELECT_DROPDOWN_MAX_HEIGHT } from './RequestStatusSelect.constants'
import {
  getRequestStatusSelectOptions,
  getRequestStatusSelectValue,
} from './RequestStatusSelect.utils'

function RequestStatusSelect({
  controlProps,
  disabled,
  dropdownFloatingConfig,
  isLoading,
  value,
  ...restProps
}) {
  const { t } = useTranslation()

  const [options, setOptions] = useState(EMPTY_LIST)

  const handleLoadStatusOptions = useAsyncCallback(() => {
    return getRequestStatuses()
      .then(({ data }) => {
        setOptions(data?.results?.objects || EMPTY_LIST)
      })
      .catch(() => {
        setOptions(EMPTY_LIST)
      })
  }, [])

  useEffect(() => {
    handleLoadStatusOptions()
  }, [])

  const preparedOptions = getRequestStatusSelectOptions(options, t)

  const preparedValue = getRequestStatusSelectValue(value, t)

  const isSelectDisabled = disabled || isLoading || preparedOptions.length === 0

  const preparedControlProps = {
    ...controlProps,
    contentProps: {
      ...controlProps?.contentProps,
      ValueItem:
        controlProps?.contentProps?.ValueItem || RequestStatusSelectInfo,
    },
  }

  return (
    <ButtonSelect
      {...restProps}
      controlProps={preparedControlProps}
      disabled={isSelectDisabled}
      dropdownFloatingConfig={{
        ...dropdownFloatingConfig,
        dropdownPlacement:
          dropdownFloatingConfig?.dropdownPlacement ||
          FLOATING_ELEMENT_PLACEMENT.bottom,
        dropdownStyles: {
          ...dropdownFloatingConfig?.dropdownStyles,
          maxHeight: REQUEST_STATUS_SELECT_DROPDOWN_MAX_HEIGHT,
        },
        maxWidthByRef: dropdownFloatingConfig?.maxWidthByRef ?? true,
      }}
      listProps={{
        headerProps: {
          Search: null,
        },
        itemProps: {
          contentProps: {
            Info: RequestStatusSelectInfo,
          },
        },
      }}
      options={preparedOptions}
      value={preparedValue}
    />
  )
}

export default RequestStatusSelect
